var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallBulletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.49121C6.44772 6.49121 6 6.0435 6 5.49121C6 4.93893 6.44772 4.49121 7 4.49121C7.55228 4.49121 8 4.93893 8 5.49121C8 6.0435 7.55228 6.49121 7 6.49121Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.49121C2.44772 6.49121 2 6.0435 2 5.49121C2 4.93893 2.44772 4.49121 3 4.49121C3.55228 4.49121 4 4.93893 4 5.49121C4 6.0435 3.55228 6.49121 3 6.49121Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.50684C9.44772 2.50684 9 2.05912 9 1.50684C9 0.954551 9.44772 0.506836 10 0.506836C10.5523 0.506836 11 0.954551 11 1.50684C11 2.05912 10.5523 2.50684 10 2.50684Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.50348C5.44772 2.50348 5 2.05652 5 1.50516C5 0.953801 5.44772 0.506836 6 0.506836C6.55228 0.506836 7 0.953801 7 1.50516C7 2.05652 6.55228 2.50348 6 2.50348Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10.4932C4.44772 10.4932 4 10.0454 4 9.49316C4 8.94088 4.44772 8.49316 5 8.49316C5.55228 8.49316 6 8.94088 6 9.49316C6 10.0454 5.55228 10.4932 5 10.4932Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10.4932C0.447715 10.4932 0 10.0454 0 9.49316C0 8.94088 0.447715 8.49316 1 8.49316C1.55228 8.49316 2 8.94088 2 9.49316C2 10.0454 1.55228 10.4932 1 10.4932Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBulletIcon);
export default __webpack_public_path__ + "static/media/SmallBulletIcon.60fc141a81bdd186e6328b93702bd3c6.svg";
export { ForwardRef as ReactComponent };